import React, { Component, Fragment } from "react";
import "./App.css";
import Login from "./modules/login.js";
import Main from "./modules/main.js";
import { isMobile } from "react-device-detect";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

class App extends Component {
  state = {
    loged: false,
    user: [],
    ccForm: false,
  };

  handleLogin = (user) => {
    this.setState({
      loged: true,
      user: user[0],
    });
  };

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        console.log();
        return decodeURIComponent(pair[1]);
      }
    }
    return false;
  }

  componentDidMount() {
    if (this.getQueryVariable("ccForm") !== false) {
      this.setState({
        ccForm: true,
        loged: true,
      });
    }
  }

  render() {
    return isMobile ? (
      <>
        <div style={{ fontSize: "6vw", textAlign: "center" }}>
          BRAK OBSŁUGI WERSJI MOBILE
        </div>
      </>
    ) : (
      <>
        <div className="App">
          {this.state.loged && !this.state.ccForm ? (
            <Main user={this.state.user} />
          ) : this.state.loged && this.state.ccForm ? (
            <Main
              user={{ role: "user", name: "Konsultant CC" }}
              ccForm={this.state.ccForm}
            />
          ) : (
            <Login login={this.handleLogin} />
          )}
        </div>
      </>
    );
  }
}

export default App;
